import ScrollToAnchor from '~/src/components/scroll-to-anchor';
import icons from "../../../../content/images/desktop-icons.png";
import * as React from 'react';
export default {
  ScrollToAnchor,
  icons,
  React
};